import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionCreateDialog',
  setup(__props) {


const collections = useCollectionsStore()

async function handleSave() {
  collections.newCollection.save().then(() => {
    collections.processDialog.close()
    collections.loadSelection(collections.newCollection.slug)
    navigateTo({ name: 'collections-view', params: { slug: collections.newCollection.slug }})
  })
}

function handleCancel() {
  collections.processDialog.close()
}


return (_ctx: any,_cache: any) => {
  const _component_hy_input = _resolveComponent("hy-input")!
  const _component_hy_form = _resolveComponent("hy-form")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_CollectionSelection = _resolveComponent("CollectionSelection")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_hy_button = _resolveComponent("hy-button")!
  const _component_hy_dialog = _resolveComponent("hy-dialog")!

  return (_openBlock(), _createBlock(_component_hy_dialog, {
    modelValue: _unref(collections).processDialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(collections).processDialog) = $event)),
    title: "Save as Collection"
  }, {
    options: _withCtx(() => [
      _createVNode(_component_hy_button, {
        type: "Cancel",
        onAction: handleCancel
      })
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_hy_button, {
        type: "Save",
        primary: "",
        loading: _unref(collections).userCollection.saving,
        onAction: handleSave
      }, null, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_hy_form, {
                model: _unref(collections).newCollection
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_hy_input, { field: "name" }),
                  _createVNode(_component_hy_input, { field: "description" }),
                  _createVNode(_component_hy_input, { field: "tags" }),
                  _createVNode(_component_hy_input, { field: "public" })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                variant: "flat",
                rounded: "lg",
                "bg-color": "indigo-lighten-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CollectionSelection, { color: "indigo-lighten-5" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})